// extracted by mini-css-extract-plugin
export default {"Container":"ItemView_Container__H6N87","Attribute":"ItemView_Attribute__yogUZ","AttributeValue":"ItemView_AttributeValue__FRqP0"};